import { render, staticRenderFns } from "./No21.vue?vue&type=template&id=3ca15186&scoped=true"
import script from "./No21.vue?vue&type=script&lang=js"
export * from "./No21.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca15186",
  null
  
)

export default component.exports